namespace Sintra {

	export interface WizardData {
		name: string;
		startText?: string;
		startButtonText?: string;
		startPage: string;
		pages: {[name: string]: WizardPageData}
	}
	
	export interface WizardPageData {
		id: string;
		groupName?: string;
		primaryText?: string;
		contentHtml?: string;
		contentImage?: string;
		footerText?: string;
		hideHistoryButtons?: boolean;
		navigationButtons: Array<WizardNavButtonData>;
	}

	export interface WizardNavButtonData {
		text: string;
		secondaryText?: string;
		image?: string;
		target?: string;
		appearance?: string;
		complete?: boolean;
		setters?: DynamicObject;
	}
}